import React, { useRef, useMemo } from "react";
import RegCodeRole from "../RegCodeRole";
import { ChantButton } from "../../../../../../../CommonComponents";
import { Tooltip } from "antd";
import { copyToClipboard } from "../../../../../../../utils/helper";
import ChantSpinner from "../../../../../../../CommonComponents/ChantSpinner/ChantSpinner";
import ChantPopConfirm from "../../../../../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import GroupQR from "../../../../../../../CommonComponents/GroupQR/GroupQR";
import { normalizeRegistrationLink } from "../../../../../../../services/firebaseService/endPoints/admin/groupConfig";

const QR_SIZE = 280;

const Option4 = ({
  regCodeRole,
  showModal,
  handleTabChange,
  saveRegCodeRole,
  isRoleSaving,
  onCloseModal,
  registrationLink,
  isLoading,
  handleChangeRegistrationCode,
}) => {
  const qrRef = useRef(null);

  const normalizedLink = useMemo(
    () =>
      registrationLink ? normalizeRegistrationLink(registrationLink) : null,
    [registrationLink],
  );

  const downloadName =
    regCodeRole === "member" ? "registration-qr" : "fan-registration-qr";

  return (
    <>
      {regCodeRole && !showModal && (
        <>
          {regCodeRole === "fan" && (
            <>
              <div className="description-section">
                <p>
                  Provide group access via web link or QR code. No need to
                  pre-register members.
                </p>
                <p>
                  You are required to first set &apos;Fan&apos; (non-member)
                  permissions in Fan Settings.
                </p>
              </div>

              <div className="action-section">
                <ChantButton
                  onClick={() => {
                    handleTabChange("fan");
                  }}
                >
                  Manage Fan Permissions
                </ChantButton>
              </div>
            </>
          )}

          {regCodeRole === "member" && (
            <div className="description-section">
              <p>
                Share the web link or QR code allowing registration. No need to
                pre-register members.
              </p>
            </div>
          )}

          <>
            {registrationLink && (
              <div className="copy-section">
                <div>
                  <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                    {regCodeRole === "member"
                      ? "Registration"
                      : "Fan Registration"}
                  </p>
                  <p style={{ fontSize: "12px", marginBottom: "8px" }}>
                    (Mobile-only link)
                  </p>
                </div>

                <div className="copy-text" style={{ textAlign: "center" }}>
                  {normalizedLink?.slice(0, 40) + "..."}{" "}
                  {!isLoading && (
                    <span>
                      {" "}
                      <Tooltip title="Copy">
                        <span
                          className="copy-button"
                          onClick={() => {
                            copyToClipboard(
                              normalizedLink,
                              "Registration link copied to clipboard",
                            );
                          }}
                        >
                          <i className="fa fa-clipboard" />
                        </span>
                      </Tooltip>
                    </span>
                  )}
                </div>
              </div>
            )}

            {registrationLink && (
              <div className="qr-section">
                <p className="qr-label">
                  {regCodeRole === "member"
                    ? "Registration"
                    : "Fan Registration"}{" "}
                  (QR Code)
                  {!isLoading && (
                    <span>
                      <span
                        className="download-icon"
                        onClick={() => qrRef.current?.download()}
                      >
                        <i className="fa fa-download" />
                      </span>
                    </span>
                  )}
                </p>
                {isLoading ? (
                  <ChantSpinner />
                ) : (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <GroupQR
                      ref={qrRef}
                      url={normalizedLink}
                      size={QR_SIZE}
                      downloadName={downloadName}
                    />
                  </div>
                )}
              </div>
            )}

            {registrationLink && (
              <div className="description-section">
                <p>
                  If you feel these have been shared inappropriately generate a
                  new code.
                </p>
              </div>
            )}

            <div className="action-section">
              <ChantPopConfirm
                title="Changing this code will make the previous registration code invalid. Are you sure?"
                onConfirm={handleChangeRegistrationCode}
                onCancel={() => {}}
                okText="Yes"
                disabled={isLoading}
                loading={isLoading}
                cancelText="No"
              >
                <ChantButton>Generate New Code</ChantButton>
              </ChantPopConfirm>
            </div>
          </>
        </>
      )}

      {(showModal || !regCodeRole) && (
        <RegCodeRole
          onCloseModal={onCloseModal}
          regCodeRole={regCodeRole}
          saveRegCodeRole={saveRegCodeRole}
          isRoleSaving={isRoleSaving}
        />
      )}
    </>
  );
};

export default Option4;
